import {mapGetters} from 'vuex';
import ab from '../../mixins/ab';
import PriceCard from './PriceCard'
import Button from '../shared/Button'
import ProductDetails from './ProductDetails'
import Accounting from '../../mixins/accounting'
import PriceCardPlaceholder from './PriceCardPlaceholder'
import ImageUrlFallback from '../../mixins/imageUrlFallback'
import VehicleVisualSummary from './VehicleVisualSummary'
import VehicleCardLocalisations from '../../lang/VehicleCard';
import branding from '../../mixins/branding';
import Tooltip from '../shared/Tooltip';

require('./scss/vehicle-card.scss');

export default {
    name: 'vehicle-card',

    components: {
        'gm-button': Button,
        'gm-tooltip': Tooltip,
        PriceCard,
        PriceCardPlaceholder,
        ProductDetails,
        VehicleVisualSummary
    },

    mixins:[Accounting, ImageUrlFallback, branding],

    props: [
        'vehicle',
        'buy',
        'labels',
        'locale',
        'selectVehicle',
        'showTermsAndConditions',
        'handleLogin',
        'vehicleExternalId',
        'selectedProductType',
    ],

    template: `
    <div v-if="currentVehicle"
         class="vehicle vehicle-upgrade shadow"
    >
        <vehicle-visual-summary
          :vehicle="vehicle"
          :labels="labels"
          :currentVehicle="currentVehicle"
          :currencyIsChanging="currencyIsChanging"
          :activeProduct="activeProduct"
          :cardType="'row-source-booking'"
          :toggle-expanded="toggleDetails"
        ></vehicle-visual-summary>
        <div class="price-block-mobile" :class="{'expanded': shouldShowDetails}">
            <div class="upgrade-product w-100" data-toggle="modal" :data-target="'#current-car-details-modal-' + currentVehicle.id" :class="{'expanded': shouldShowDetails}">
                <div>
                    <img :src="icons[activeProduct.type]">
                    <span class="ml-4">{{ $t('VehicleCard.change_plan') }}</span>
                </div>
                <span class="upgrade-product-arrow"></span>
            </div>
            <div class="book-default w-100">
                <gm-button
                    @click="selectVehicleHandler(vehicle, activeProduct.id);"
                    v-if="(user && vehicle.is_drive_and_go && activeProduct.is_available) || (!vehicle.is_drive_and_go && activeProduct.is_available)"
                    type="select"
                    :mobile-classes="true"
                    :disabled="disabledButtonStatus"
                >
                    {{ labels.bookNow }}
                </gm-button>
                <gm-button
                    top-right-radius="0"
                    top-left-radius="0"
                    :disabled="true"
                    :mobile-classes="true"
                    v-if="!activeProduct.is_available"
                >
                    {{ $t('VehicleCard.age_limit', { age: activeProduct.minimum_age }) }}
                </gm-button>

                <div class="align-items-end d-flex flex-column mb-0 p-0 price-card-total">
                    <span>
                        <strong class="original-amount" v-if="activeProduct.original_price && !currencyIsChanging">{{ originalPrice(activeProduct) }}</strong>
                        <strong class="amount" v-if="currencyIsChanging">&hellip;</strong>
                        <strong class="amount original-amount-mobile" v-else>{{ vehiclePrice }}</strong>
                        <strong class="text-lowercase gm-text-black">{{ labels.extraPerDay }}</strong>
                    </span>
                    <span>
                        <gm-tooltip :text="labels.loyaltyAppliedInsteadOfPromo" class="d-inline-block" click="enabled" v-if="loyaltyHigherThanPromo">
                            <i class="fa fa-info-circle text-brand"></i>
                        </gm-tooltip>
                        <strong class="text-capitalize gm-text-black">{{ labels.total }}</strong>
                        <strong class="amount" v-if="currencyIsChanging">&hellip;</strong>
                        <strong class="gm-text-black" v-else>{{ price(activeProduct) }}</strong>
                    </span>
                </div>
            </div>
        </div>
        <div class="price-titles">
            <div
                    class="price-title"
                    :class="{ active: product.type === activeProduct.type }"
                    v-for="product in products"
                    :key="product.type"
                    @click="setActiveProduct(currentVehicle, product);"
            >
                <img :src="icons[product.type]" alt="" style="height:35px;">
                <span v-if="currencyIsChanging">&hellip;</span>
                <span v-else>{{price(product)}}</span>
            </div>
        </div>
        <div class="d-none d-sm-block prices-block">
            <div class="price-cards">
                <div
                    v-for="product in products"
                    :class = "setDisplayProduct(product)"
                    class="ml-4"
                >
                    <price-card
                        :class="{
                            active: product.type === activeProduct.type,
                            highlight: product.type === highlightedProduct
                        }"
                        class="h-100 row-price-card"
                        upsellCardType="row-product-upsell"
                        :key="product.type"
                        :product="product"
                        :vehicle="vehicle"
                        :labels="labels"
                        :buy="buy"
                        :show-terms-and-conditions="showTermsAndConditions"
                        :currency-is-changing="currencyIsChanging"
                        :select-vehicle="selectVehicleHandler"
                        :selected-currency="selectedCurrency"
                        :user="user"
                        :handle-login="handleLogin"
                        :vehicle-external-id="vehicleExternalId"
                        :selected-product-type="selectedProductType"
                        :loyalty-higher-than-promo="loyaltyHigherThanPromo"
                    ></price-card>
                    <price-card-placeholder v-for="n in placeholderSpaces" :key="n"></price-card-placeholder>
                </div>
            </div>
        </div>

        <div class="modal gm-full-modal" tabindex="-1" :id="'current-car-details-modal-' + currentVehicle.id">
            <div class="modal-dialog">
                <div class="modal-content overflow-auto">
                    <div class="modal-body">
                        <div class="d-flex align-items-center">
                            <button type="button" class="btn btn-icon h2" data-dismiss="modal" aria-label="Close">
                                <img :src="brandingImagesPath('/images/svgs/close-black.svg')" alt="Close" />
                            </button>
                            <span class="ml-3 h2">{{ $t('VehicleCard.change_plan') }}</span>
                        </div>

                        <div>
                            <transition name="fade">
                                <div class="prices">
                                    <div
                                        class="price"
                                        v-for="product in reversedProducts"
                                        :class="product.type"
                                        :key="product.type"
                                    >
                                        <div class="price-body">
                                            <div class="header justify-content-center">
                                                <div class="product-type">
                                                    <img :src="icons[product.type]">
                                                </div>
                                            </div>
                                            <product-details
                                                :show-terms-and-conditions="showTermsAndConditions"
                                                :product="product"
                                                :currency-is-changing="currencyIsChanging"
                                            ></product-details>
                                        </div>
                                        <div class="mobile-products-price">
                                            <div v-if="product.total_price >= activeProduct.total_price"  class="total">
                                                &plus;&nbsp;{{ selectedPriceDiffBasePrice(activeProduct, product, quoteHireDuration) }} <small>{{ labels.extraPerDay }}</small>
                                            </div>
                                            <div v-else  class="total">
                                                &minus;&nbsp;{{ selectedPriceDiffBasePrice(activeProduct, product, quoteHireDuration) }} <small>{{ labels.extraPerDay }}</small>
                                            </div>
                                        </div>
                                        <div class="choose-product disabled-button" v-if="product.type === activeProduct.type" disabled>
                                            {{ $t('VehicleCard.current') }}
                                        </div>
                                        <div class="choose-product" @click="selectVehicleHandler(vehicle, product.id)" v-else-if="product.is_available" data-dismiss="modal">
                                            {{ $t('VehicleCard.upgrade') }}
                                        </div>
                                        <div class="choose-product product-disabled" disabled="disabled" v-if="!product.is_available" data-dismiss="modal">
                                            {{ $t('VehicleCard.age_limit', {age: product.minimum_age}) }}
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`,
    i18n: VehicleCardLocalisations,
    data() {
        return {
            currencyIsChanging:false,
            imageErrorUrls:[],
            currentVehicle: null,
            disabledButtonStatus: false,
            product: null,
            showAllProducts: false,
            products: [],
            reversedProductsList: [],
            displayProducts: {
                BAS: "basic",
                PMP: "premium plus+"
            },
            icons: {
                BAS: this.brandingImagesPath("/images/vehicle-listing/basic-badge.svg"),
                PLU: this.brandingImagesPath("/images/vehicle-listing/plus-badge.svg"),
                PRE: this.brandingImagesPath("/images/vehicle-listing/premium-badge.svg"),
                PMP: this.brandingImagesPath("/images/vehicle-listing/premium-plus-badge.svg")
            },
            productLabels: {
                BAS: "basic",
                PLU: "plus",
                PRE: "premium",
                PMP: "premium plus+"
            },
            highlightedProduct: 'PMP',
            carDetailsModalToShow: null,
            vehiclePricePerDay: 0,
            shouldShowDetails: false,
        }
    },

    mounted() {
        this.currentVehicle = this.vehicle;
        this.mapProducts(this.currentVehicle);
        window.bus.$on('currency.changed',this.currencyChanging);
        window.bus.$on('vehicle.selected', this.disableButton);
        this.loyaltyHigherThanPromo = this.quote.is_loyalty_higher_than_promo;
    },

    beforeDestroy() {
        window.bus.$off('currency.changed',this.currencyChanging);
    },

    watch:{
        vehicle: function(vehicle) {
            this.mapProducts(vehicle,true);
            this.currencyIsChanging = false;
        },
        quoteHireDuration: function(duration) {
            this.vehiclePricePerDay = this.originalPricePerDay(this.activeProduct, duration);
        }
    },

    computed: Object.assign({
            vehiclePrice() {
              return this.quoteHireDuration > 1
                ? this.originalPricePerDay(this.activeProduct, this.quoteHireDuration)
                : this.formatMoney(this.activeProduct.total_price, this.selectedCurrency.code);
            },
            reversedProducts(){
                this.reversedProductsList = [...this.products];
                return this.reversedProductsList.reverse();
            },
            activeProduct(){
                let activeProducts =this.products.filter((product) => product.active);
                return activeProducts.length > 0 ? activeProducts[0] : {};
            },
            pluralizationEnabled() {
                return !['tr'].includes(this.locale);
            },
            userLoyalty() {
                if (!this.user) {
                    return null;
                }

                const data = this.user.loyalty_level.data;

                return {
                    name: data.name,
                    image: this.brandingImagesPath(`/images/loyalty-icons/medals/${data.slug}.svg`),
                };
            },
            loyaltyDiscountApplied() {
                return this.vehicle.loyalty_discount_applied && this.userLoyalty;
            },
            pickupLocationIsUK() {
                return this.pickupLocation.country && this.pickupLocation.country.data.id === 1;
            },
            placeholderSpaces(){
                return 4 - this.products.length;
            },
            productUpgrades() {
                return this.products.filter((product) => {
                    return product.type !== this.vehicle.default_product.type;
                });
            },
            loyaltyHigherThanPromo() {
                if (!this.quote) {
                    return false;
                }

                return this.quote.is_loyalty_higher_than_promo;
            }
        },
        mapGetters({
            quotePaymentType: 'quotePaymentType',
            quoteHireDuration: 'quoteHireDuration',
            selectedCurrency: 'selectedCurrency',
            user: 'getQuoteUser',
            quote: 'getQuote',
            pickupLocation: 'getPickupLocation',
        })
    ),

    methods: {
        toggleDetails(value) {
            this.shouldShowDetails = value;
        },
        currencyChanging(){
            this.currencyIsChanging = true;
        },
        mapProducts(vehicle, isUpdate) {
            this.products = vehicle.products.data.map(product => {
                let originalProduct = this.products.filter((previousProduct) => previousProduct.id == product.id);

                let aProduct = Object.assign(
                    originalProduct.length > 0
                        ? originalProduct[0]
                        : {},
                    product
                );

                if(!isUpdate) {
                    aProduct.active = false;

                    if (vehicle.default_product && product.type === vehicle.default_product.type) {
                        aProduct.active = true;
                    }
                }

                return aProduct;
            })
        },
        upgradeProduct() {
            this.showAllProducts = !this.showAllProducts;
        },
        setActiveProduct(vehicle, product) {
            this.products = this.products.map(aProduct => {
                aProduct.active = false;
                return aProduct;
            });
            product.active = true;
        },
        setDisplayProduct(product) {
            if (this.displayProducts[product.type]) {
                return 'd-block';
            }

            return 'd-none';
        },
        disableButton() {
            this.disabledButtonStatus = true;
        },
        selectVehicleHandler(vehicle, activeProductId) {
            window.bus.$emit('vehicle.selected');
            window.bus.$emit('vehicle.selecting');
            this.selectVehicle(vehicle, activeProductId);
        },
    }
};
